import React, { useEffect, useMemo } from 'react';
import Select from 'react-select';
import styled from 'styled-components';

import { SelectOption, ISpecialHandlingCode } from '../../globals/interfaces';

interface Props {
    shcs: Array<ISpecialHandlingCode>;
    selectedShcs: Array<SelectOption>;
    setSelectedShcs: React.Dispatch<React.SetStateAction<Array<SelectOption>>>;
    setValue?: (value: string) => void;
}

export default function SpecialHandlingCodes ({
    shcs,
    selectedShcs,
    setSelectedShcs,
    setValue
}: Props) {

    const shcOptions: Array<SelectOption> = useMemo(() => {
        const arr: Array<SelectOption> = [];
        for (let i = 0; i < shcs.length; i++) {
            const { s_special_handling_code } = shcs[i];
            if (s_special_handling_code.length > 0) {
                arr.push({
                    label: s_special_handling_code,
                    value: s_special_handling_code
                });
            }
        }
        return arr;
    }, [shcs]);
    
    return (
        <SelectContainer>
            <Select
                isMulti
                name="shcs"
                value={selectedShcs}
                onChange={setSelectedShcs}
                options={shcOptions}
                className="basic-multi-select"
                classNamePrefix="select"
            />
        </SelectContainer>
    );
}

const SelectContainer = styled.div`

`;